import * as React from 'react';
import xssFilters from 'xss-filters';
import { StringMode } from '@comall-backend-builder/types';
import { services } from '@comall-backend-builder/core';
import { errorHandle } from '../../../services';

export class StringReportsUrlMode extends StringMode {
    /**
     * 报表下载
     */
    public getAvailableDisplayComponent(value: any, displayInfo: any) {
        const { row, textProperty, conditionProperty, isSignature } = displayInfo;
        value = xssFilters.uriInDoubleQuotedAttr(value);
        console.log(row, 'row');

        /**
         * 获取blob
         * @param url
         * 由于谷歌浏览器有时下载不了
         */

        const getBlob = (url: string): any => {
            return new Promise((resolve) => {
                const xhr = new XMLHttpRequest();
                xhr.open('GET', url, true);
                xhr.responseType = 'blob';
                xhr.onload = () => {
                    if (xhr.status === 200) {
                        resolve(xhr.response);
                    }
                };
                xhr.send();
            });
        };

        const toHttps = (url: string) => String(url ?? '').replace(/^http:\/\//i, 'https://');

        // 此函数只供报表导出管理中发货单类型的报表下载调用，因为此报表对接了鸿鹄中台报表需要签名
        const hanldePrivateDownLoad = async (filePath: string) => {
            services.api
                .get({ download_url: filePath }, { apiPath: `/shippingOrder/exportDownload` })
                .then(async (res: any) => {
                    if (Object.keys(res).length != 0) {
                        const { data } = res;
                        const fileName = filePath.substring(filePath.lastIndexOf('/') + 1);
                        const url = toHttps(data);
                        const blob: any = await getBlob(url);
                        const downloadLink = document.createElement('a');
                        downloadLink.href = window.URL.createObjectURL(blob);
                        downloadLink.download = fileName;
                        downloadLink.target = '_blank';
                        downloadLink.click();
                    }
                })
                .catch((e: any) => {
                    errorHandle(e);
                });
        };

        const hanldeNotdiffTypeDownLoad = async (filePath: any, fileName: string) => {
            services.api
                .get({ filePath }, { apiPath: `/exportQueQue/download` })
                .then(async (res: any) => {
                    if (Object.keys(res).length != 0) {
                        const { data } = res;
                        const url = toHttps(data);
                        const blob: any = await getBlob(url);
                        const downloadLink = document.createElement('a');
                        downloadLink.href = window.URL.createObjectURL(blob);
                        downloadLink.download = fileName;
                        downloadLink.target = '_blank';
                        downloadLink.click();
                    }
                })
                .catch((e: any) => {
                    errorHandle(e);
                });
        };

        return (
            <div>
                {!conditionProperty || row[conditionProperty] ? (
                    row.diffType == 1 ? (
                        <a onClick={() => hanldeNotdiffTypeDownLoad(value, row[textProperty])}>
                            {row[textProperty]}
                        </a>
                    ) : // 因为此下载文件逻辑导入管理和到处管理模块都在使用，增加此判断只意味着报表导出的发货单报表下载
                    row[isSignature] === 'SHIPPING_ORDER' ? (
                        <a onClick={() => hanldePrivateDownLoad(value)}>{row[textProperty]}</a>
                    ) : (
                        <a href={value} target="_blank">
                            {row[textProperty]}
                        </a>
                    )
                ) : null}
            </div>
        );
    }
}
